import React, { useContext, useMemo, useState } from "react";
import { Input, Label, Button } from "reactstrap";
import ExportJsonExcel from "js-export-excel";
import { AuthContext } from "../../contexts/AuthContext";
import { Kpis, Pagina, Tabla, Tarjeta, fmtM, fmtN, fmtP, useDatos, usePeriodo } from "./comun";

const CAMPOS = [["cliente", "Cliente"], ["vendedor", "Vendedor"], ["vino", "Vino"], ["tipo", "Tipo de vino"], ["region", "Region"]];
const pct = (u, v) => (v ? (u / v) * 100 : 0);

function agrupa(filas, llave, base) {
  const m = new Map();
  filas.forEach((f) => {
    const k = f[llave];
    const g = m.get(k) || { ...base(f), botellas: 0, venta: 0, costo: 0, utilidad: 0 };
    ["botellas", "venta", "costo", "utilidad"].forEach((c) => { g[c] += f[c]; });
    m.set(k, g);
  });
  return [...m.values()].map((g) => ({ ...g, margen: pct(g.utilidad, g.venta) }));
}

function ReporteUtilidades() {
  const { user } = useContext(AuthContext);
  const periodo = usePeriodo("tres");
  const { datos, error } = useDatos(`/utilidades/${periodo.inicio}/${periodo.fin}`);
  const [vista, setVista] = useState("venta");
  const [filtros, setFiltros] = useState({});
  const [orden, setOrden] = useState("utilidad");

  const opciones = useMemo(() => Object.fromEntries(CAMPOS.map(([k]) => [k, [...new Set((datos || []).map((f) => f[k]))].sort()])), [datos]);
  const filtradas = useMemo(() => (datos || []).filter((f) => CAMPOS.every(([k]) => !filtros[k] || f[k] === filtros[k])), [datos, filtros]);
  const filas = useMemo(() => {
    const g = vista === "venta"
      ? agrupa(filtradas, "nota", (f) => ({ nota: f.nota, fecha: f.fecha, cliente: f.cliente, vendedor: f.vendedor }))
      : agrupa(filtradas, "vino", (f) => ({ vino: f.vino, tipo: f.tipo, region: f.region }));
    return g.sort((a, b) => b[orden] - a[orden]);
  }, [filtradas, vista, orden]);

  const t = filtradas.reduce((a, f) => ({ b: a.b + f.botellas, v: a.v + f.venta, c: a.c + f.costo, u: a.u + f.utilidad }), { b: 0, v: 0, c: 0, u: 0 });
  const cols = vista === "venta"
    ? [{ t: "Nota", k: "nota" }, { t: "Fecha", k: "fecha" }, { t: "Cliente", k: "cliente" }, { t: "Vendedor", k: "vendedor" }]
    : [{ t: "Vino", k: "vino" }, { t: "Tipo", k: "tipo" }, { t: "Region", k: "region" }];
  const numeros = [{ t: "Botellas", k: "botellas", f: fmtN, n: 1 }, { t: "Venta", k: "venta", f: fmtM, n: 1 }, { t: "Costo", k: "costo", f: fmtM, n: 1 }, { t: "Utilidad", k: "utilidad", f: fmtM, n: 1 }, { t: "Margen", k: "margen", f: fmtP, n: 1 }];

  const excel = () => {
    const claves = [...cols, ...numeros];
    new ExportJsonExcel({
      fileName: vista === "venta" ? "UtilidadPorVenta" : "UtilidadPorVino",
      datas: [{ sheetName: "Utilidades", sheetData: filas.map((f) => Object.fromEntries(claves.map((c) => [c.t, typeof f[c.k] === "number" ? Math.round(f[c.k] * 100) / 100 : f[c.k]]))), sheetFilter: claves.map((c) => c.t), sheetHeader: claves.map((c) => c.t) }],
    }).saveExcel();
  };

  if (!user.menu_reportes) return <Pagina titulo="Utilidades" />;
  return (
    <Pagina titulo="Utilidades" subtitulo="Utilidad por venta y por vino, ya con descuento" periodo={periodo} error={error} cargando={!datos}
      acciones={user.exportar ? <Button size="sm" color="primary" onClick={excel}>Exportar Excel</Button> : null}>
      {datos && <>
        <div className="rp-selects">
          {CAMPOS.map(([k, label]) => (
            <div key={k}>
              <Label>{label}</Label>
              <Input bsSize="sm" type="select" value={filtros[k] || ""} onChange={(e) => setFiltros({ ...filtros, [k]: e.target.value })}>
                <option value="">Todos</option>
                {opciones[k].map((o) => <option key={o} value={o}>{o}</option>)}
              </Input>
            </div>
          ))}
          <div>
            <Label>Ordenar por</Label>
            <Input bsSize="sm" type="select" value={orden} onChange={(e) => setOrden(e.target.value)}>
              <option value="utilidad">Utilidad</option><option value="venta">Venta</option><option value="margen">Margen</option><option value="botellas">Botellas</option>
            </Input>
          </div>
        </div>
        <Kpis items={[{ t: "Venta", v: fmtM(t.v) }, { t: "Costo", v: fmtM(t.c) }, { t: "Utilidad", v: fmtM(t.u) }, { t: "Margen", v: fmtP(pct(t.u, t.v)) }, { t: "Botellas", v: fmtN(t.b) }]} />
        <div className="rp-filtros">
          <button type="button" className={vista === "venta" ? "activo" : ""} onClick={() => setVista("venta")}>Por venta</button>
          <button type="button" className={vista === "vino" ? "activo" : ""} onClick={() => setVista("vino")}>Por vino</button>
        </div>
        <Tarjeta titulo={vista === "venta" ? "Utilidad por venta" : "Utilidad por vino"} ancho><Tabla filas={filas} columnas={[...cols, ...numeros]} /></Tarjeta>
      </>}
    </Pagina>
  );
}
export default ReporteUtilidades;
